import * as ko from 'knockout'
import Guard from '../../../../AppUtils/Framework/Guard'
import { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import ObservableRacePage from '../../../Model/Observables/ObservableRacePage'
import type { IUseGiddyUp } from '../../Pages/Starters/IUseGiddyUp'
import type { IBaseBetType } from './IBaseBetType'

export class BaseBetType implements IBaseBetType {
  public doubleProvDivAllowed: ko.PureComputed<boolean>
  public quaddieProvDivAllowed: ko.PureComputed<boolean>
  public raceInfo: ObservableRacePage
  public raceStarters: {
    Key: ObservableRaceKey
    Value: ko.ObservableArray<IObservableStarter>
  }
  public bettingContext: BettingInformation
  public selections: ko.ObservableArray<IObservableStarter>
  public useGiddyUp: IUseGiddyUp

  constructor(
    raceInfo: ObservableRacePage,
    raceStarters: ko.Observable<{
      Key: ObservableRaceKey
      Value: ko.ObservableArray<IObservableStarter>
    }>,
    selections: ko.ObservableArray<IObservableStarter>,
    bettingContext: BettingInformation,
    useGiddyUp: IUseGiddyUp
  ) {
    Guard.notNull(raceInfo)

    this.raceInfo = raceInfo
    this.raceStarters = raceStarters()
    this.bettingContext = bettingContext
    this.selections = selections
    this.useGiddyUp = useGiddyUp

    this.doubleProvDivAllowed = ko.pureComputed(() => {
      return (
        this.bettingContext.selectedBetType().betType() === 'WinPlace' &&
        this.raceInfo.hasDoubleProvDivs()
      )
    })

    this.quaddieProvDivAllowed = ko.pureComputed(() => {
      return (
        this.bettingContext.selectedBetType().betType() === 'WinPlace' &&
        this.raceInfo.hasQuaddieProvDivs()
      )
    })
  }
}
